import React from "react";
import CommunityViewPage from "../community/components/CommunityViewPage";
import { SHARE_WITH_NEIGHBORS } from "../community/constants";

export default function ViewShareWithNeighborsPage() {
  return <CommunityViewPage section={SHARE_WITH_NEIGHBORS} />;
}
